import {i18n} from '@online-offer/i18n';
import {Heading, HStack, Text} from 'platform/foundation';

type TimerType = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
};

export const Timer = (props: TimerType) => (
  <HStack align="center" justify="space-between" width="100%" maxWidth={80}>
    <HStack justify="center" align="center" spacing={1}>
      <Heading size={2}>{props.days.toString()}</Heading>
      <Text size="small">{i18n.t('timerCard.timer.d')}</Text>
    </HStack>
    <Heading size={3} color="tertiary">
      :
    </Heading>
    <HStack justify="center" align="center" spacing={1}>
      <Heading size={2}>{props.hours.toString().padStart(2, '0')}</Heading>
      <Text size="small">{i18n.t('timerCard.timer.h')}</Text>
    </HStack>
    <Heading size={3} color="tertiary">
      :
    </Heading>
    <HStack justify="center" align="center" spacing={1}>
      <Heading size={2}>{props.minutes.toString().padStart(2, '0')}</Heading>
      <Text size="small">{i18n.t('timerCard.timer.m')}</Text>
    </HStack>
    <Heading size={3} color="tertiary">
      :
    </Heading>
    <HStack justify="center" align="center" spacing={1}>
      <Heading size={2}>{props.seconds.toString().padStart(2, '0')}</Heading>
      <Text size="small">{i18n.t('timerCard.timer.s')}</Text>
    </HStack>
  </HStack>
);
